import { useEffect } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import styles from './index.module.scss';
import gsap from 'gsap';

const PopupAnimacion = () => {
  useEffect(() => {
    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.popup-plane-js',
          {
            y: 0,
            x: 0
          },
          {
            y: -250,
            x: 250,
            duration: 2,
            ease: 'back.in'
          }
        )
        .fromTo(
          '.popup-plane-js',
          {
            y: 1000,
            x: -1000
          },
          {
            y: 1,
            x: 1,
            duration: 4,
            ease: 'power2.out'
          }
        )
        .to('.popup-plane-js', {
          y: 0,
          x: 0,
          duration: 2,
          ease: 'power2.out'
        });
    });
  }, []);

  return (
    <>
      <div className="absolute z-1 inset-0">
        <Image src="/images/popup/chica.svg" width={247} height={406} alt="" />
      </div>
      <div className="absolute top-0 left-0">
        <div className="relative w-[10.3rem] h-[10.3rem]">
          <svg
            className={cn('absolute w-[10.3rem] h-auto', styles.dottedCircle)}
            viewBox="0 0 103 103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="51.5"
              cy="51.5"
              r="51.3079"
              stroke="#EE4424"
              strokeWidth="0.384131"
              strokeDasharray="2.3 2.3"
            />
          </svg>
          <Image src="/images/popup/hop.svg" width={103} height={103} alt="" />
        </div>
      </div>
      <div className="absolute z-1 top-20 right-20">
        <Image
          src="/images/popup/plane.svg"
          width={105}
          height={98}
          alt=""
          className="popup-plane-js"
        />
      </div>
    </>
  );
};
export default PopupAnimacion;
